import { Component } from 'react';
import { connect } from 'react-redux';
import { getCountry } from '../../../../../../iwIntlProvider/CountryProvider';
import DownloadButton from '../../../../../ui/downloadButton/DownloadButton';
import styles from '../SignDocumentModals.module.css';

import SigningDocumentContentPending from '../SigningDocumentContentPending';

const mapStateToProps = ({ drawDown }) => ({
    ...drawDown
});

class ViewSignedDocumentModal extends Component {
    renderDownloadButton() {
        const { signedDownloadURL } = this.props;
        if (signedDownloadURL) {
            return (
                <div className={styles.downloadWrapper}>
                    <a
                        href={signedDownloadURL}
                        download
                        className="download-pdf-button"
                    >
                        <DownloadButton
                            pending={false}
                            className={styles.downloadButton}
                        />
                    </a>
                </div>
            );
        } else {
            return null;
        }
    }

    renderContent() {
        const { signedReady, signedDocumentContent } = this.props;

        if (!signedDocumentContent) {
            return null;
        }

        if (signedReady) {
            const content = { __html: signedDocumentContent };
            return <div dangerouslySetInnerHTML={content} />;
        }

        return <SigningDocumentContentPending />;
    }

    render() {
        const { signedTitle, signedSubTitle } = this.props;
        const content = this.renderContent();
        const downloadButton = this.renderDownloadButton();

        return (
            <div className={styles.Modal}>
                <header className={styles.header}>
                    <div className={styles.title}>
                        <h1>{signedTitle}</h1>
                        {getCountry() !== 'DE' ? (
                            <h2>{signedSubTitle}</h2>
                        ) : null}
                    </div>
                    {downloadButton}
                </header>
                <article>{content}</article>
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(ViewSignedDocumentModal);
